import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './style.css';
createRoot(document.getElementById('root')!).render(<React.StrictMode><App /></React.StrictMode>);
import './workspace-ipad.css';
import './library-ipad.css';
import './chat-ipad.css';
